"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalRCD1Key = exports.ExternalED22519Key = exports.RCD1Key = exports.ED25519Key = void 0;
const nacl = __importStar(require("tweetnacl"));
const address_1 = require("../address");
const common_1 = require("../common");
const core_1 = require("../core");
const encoding_1 = require("../encoding");
const key_1 = require("./key");
class BaseED25519Key extends key_1.BaseKey {
    constructor(address) {
        super(address);
        this.address = address;
    }
    static make(type, seedOrKey) {
        let kp;
        if (!seedOrKey) {
            kp = nacl.sign.keyPair();
        }
        else if (seedOrKey.length == 64) {
            kp = {
                publicKey: seedOrKey.slice(32),
                secretKey: seedOrKey,
            };
        }
        else if (seedOrKey.length == 32) {
            kp = nacl.sign.keyPair.fromSeed(seedOrKey);
        }
        else {
            throw new Error(`invalid key: expected 64 or 32 bytes, got ${seedOrKey.length}`);
        }
        return address_1.PrivateKeyAddress.from(type, kp.publicKey, kp.secretKey);
    }
    async signRaw(signature, message) {
        const sigMdHash = (0, common_1.sha256)((0, encoding_1.encode)(signature));
        const hash = (0, common_1.sha256)(common_1.Buffer.concat([sigMdHash, message.hash()]));
        return nacl.sign.detached(hash, this.address.privateKey);
    }
}
class ED25519Key extends BaseED25519Key {
    static generate() {
        return new this(this.make(core_1.SignatureType.ED25519));
    }
    static from(seedOrKey) {
        return new this(this.make(core_1.SignatureType.ED25519, seedOrKey));
    }
}
exports.ED25519Key = ED25519Key;
class RCD1Key extends BaseED25519Key {
    static generate() {
        return new this(this.make(core_1.SignatureType.RCD1));
    }
    static from(seedOrKey) {
        return new this(this.make(core_1.SignatureType.RCD1, seedOrKey));
    }
}
exports.RCD1Key = RCD1Key;
/**
 * @deprecated Use {@link SimpleExternalKey}
 */
class ExternalED22519Key extends key_1.SimpleExternalKey {
    constructor(address, sign) {
        super(address, sign);
        if (address.type != core_1.SignatureType.ED25519) {
            throw new Error(`address is ${address.type}, not ED25519`);
        }
    }
}
exports.ExternalED22519Key = ExternalED22519Key;
/**
 * @deprecated Use {@link SimpleExternalKey}
 */
class ExternalRCD1Key extends key_1.SimpleExternalKey {
    constructor(address, sign) {
        super(address, sign);
        if (address.type != core_1.SignatureType.RCD1) {
            throw new Error(`address is ${address.type}, not RCD1`);
        }
    }
}
exports.ExternalRCD1Key = ExternalRCD1Key;
//# sourceMappingURL=ed25519.js.map